export const NoSellerIllustraction = () => {
  return <div>No Seller</div>;
};
